<template>
  <div class="guests-previous" @mouseenter="mouseEnter" @mouseleave="mouseLeave">
    <ModuleNav :normal="nav.normal" :hover="nav.hover" :isInModule="isInModule"/>
    <div class="right">
      <div class="header">
        <img
          src="https://summit-img.geekpark.net/08-%E5%BE%80%E5%B1%8A%E5%98%89%E5%AE%BE-%E4%B8%AD%E6%96%87.svg">
        <img
          src="https://summit-img.geekpark.net/08-%E5%BE%80%E5%B1%8A%E5%98%89%E5%AE%BE-%E8%8B%B1%E6%96%87.svg">
      </div>
      <div class="content">
        <div class="item" v-for="(item,index) in guests" :key="index">
          <div class="guest-photo-box"
               :style="{background:`url('${item.avator.url}') 0 0/cover`}"></div>
          <p class="guest-info">
            <span>{{item.name}}</span>
            <span>{{item.company}}</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import ModuleNav from './ModuleNav';
  import { mapState } from 'vuex';

  export default {
    name: 'GuestsPrevious',
    components: { ModuleNav },
    computed: {
      ...mapState({
        nav: state => state.guestsPrevious.nav,
      }),
      guests() {
        // return this.$store.state.global.guests.filter(item => item.speech && item.speech.title === '往届嘉宾');
        return this.$store.state.global.activity.themes[0].speeches[0].guests;
      }
    },
    data() {
      return {
        isInModule: false,
      };
    },
    methods: {
      mouseEnter() {
        this.isInModule = true;
      },
      mouseLeave() {
        this.isInModule = false;
      }
    }
  };
</script>

<style scoped lang="less">
  .guests-previous {
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    margin-left: 10vh;
  }

  .right {
    height: 100vh;
    padding: 5.5vh 7vh 0 7vh;
    margin-left: 2vh;
    background: url("https://summit-img.geekpark.net/%E5%BE%80%E5%B1%8A%E5%98%89%E5%AE%BE%E5%BA%95%E5%9B%BE.svg") 0 0/contain no-repeat;

    .header {
      display: flex;
      justify-content: space-between;

      img:first-of-type {
        height: 4vh;
      }

      img:last-of-type {
        height: 3vh;
      }
    }

    .content {
      width: 240vh;
      margin-top: 3vh;
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      box-sizing: content-box;
      background: #fff;
      padding: 2vh 2vh 0 2vh;

      &::after {
        content: '';
        flex: auto;
      }
    }
  }

  .item {
    box-sizing: border-box;
    width: 30vh;
    height: 20vh;
  }

  .item:nth-child(8n + 8) .guest-photo-box {
    /*border-right: 1px solid #979797;*/
  }

  .guest-photo-box {
    /*border-left: 1px solid #979797;*/
    /*border-top: 1px solid #979797;*/
    /*border-bottom: 1px solid #979797;*/
    height: 15vh;
    background-color: #d8d8d8;
  }

  .guest-info {
    margin-top: 1vh;
    text-align: left;
    font-size: 1.5vh;
    font-weight: 500;

    span:first-of-type {
      color: #1d1d1d;
    }

    span:last-of-type {
      margin-left: 0.5em;
      color: #ff3c00;
    }
  }
</style>
